import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getUser } from '../../../api/users';

const useUser = (
  id: string,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>,
  organization_id?: string
) => {
  return useQuery({
    queryKey: ['user', id],
    queryFn: () => getUser(id, organization_id),
    ...options,
  });
};

export default useUser;
